
export const addReferralParam = (url: string, source: 'badge' | 'contractor' = 'badge'): string => {
  if (!url) return url;
  
  try {
    // For internal links, ensure we're using homeprosokc.com
    const baseUrl = 'https://homeprosokc.com';
    
    // Clean the URL first - remove any accidental domain duplications
    let cleanUrl = url.replace(/https?:\/\/homeprosokc\.com/g, '');
    
    // Ensure the URL starts with a forward slash if it's a path
    if (!cleanUrl.startsWith('/') && !cleanUrl.startsWith('http')) {
      cleanUrl = `/${cleanUrl}`;
    }
    
    // Clean up trailing commas in slugs if present (most common in contractor slugs)
    if (cleanUrl.includes('-,')) {
      cleanUrl = cleanUrl.replace(/-,/g, '-');
    }
    
    // Determine if this is an internal or external link
    const isInternalLink = !cleanUrl.startsWith('http');
    const fullUrl = isInternalLink ? `${baseUrl}${cleanUrl}` : cleanUrl;
    
    const urlObj = new URL(fullUrl);
    urlObj.searchParams.set('ref', source);
    
    return urlObj.toString();
  } catch (e) {
    console.error('Invalid URL:', url);
    return url;
  }
};

export const addContractorReferral = (url: string): string => {
  if (!url) return url;
  
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('ref', 'homeprosokc.com');
    return urlObj.toString();
  } catch (e) {
    console.error('Invalid URL:', url);
    return url;
  }
};

export const normalizeServiceType = (serviceType: string): string => {
  // Map of service type variations to their canonical forms
  const serviceTypeMap: Record<string, string> = {
    'general-contractor': 'general-contracting',
    'general-contractors': 'general-contracting',
    'house-cleaners': 'house-cleaning',
    'house-cleaning': 'house-cleaning-services',
    'tree-services': 'tree-service',
  };
  
  return serviceTypeMap[serviceType.toLowerCase()] || serviceType;
};

export const cleanSlug = (slug: string): string => {
  if (!slug) return slug;
  
  // Remove trailing commas
  return slug.replace(/-,$/g, '');
};

export const normalizeContractorName = (name: string): string => {
  if (!name) return name;
  
  // Rename "Edmond Tree Service" to "Redbud Tree Service"
  if (name.toLowerCase().includes('edmond tree service')) {
    return name.replace(/edmond tree service/gi, 'Redbud Tree Service');
  }
  
  return name;
};
